import React from 'react';

// Bannière d'erreur réutilisable : message clair + action proposée (réessayer) si l'utilisateur
// peut corriger lui-même (ex. erreur de chargement réseau).
export default function ErrorBanner({ message, onRetry, retryLabel = 'Réessayer', style }) {
  if (!message) return null;
  return (
    <div role="alert" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
      padding: '11px 14px', borderRadius: 12, marginBottom: 12,
      background: 'rgba(214,64,46,0.08)', border: '1px solid rgba(214,64,46,0.25)',
      color: 'var(--coral, #D6402E)', fontSize: 13, fontWeight: 600, ...style,
    }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
          strokeLinecap="round" style={{ flexShrink: 0 }}>
          <circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16.5v.5" />
        </svg>
        <span>{message}</span>
      </span>
      {onRetry && (
        <button onClick={onRetry} style={{
          flexShrink: 0, background: 'var(--coral, #D6402E)', color: '#fff', border: 'none',
          borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer',
        }}>{retryLabel}</button>
      )}
    </div>
  );
}

// Petit message d'erreur sous un champ de formulaire.
export function FieldError({ message }) {
  if (!message) return null;
  return (
    <span style={{ display: 'block', marginTop: 4, fontSize: 12, color: 'var(--coral, #D6402E)', fontWeight: 600 }}>
      {message}
    </span>
  );
}
